var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressPointer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 90,
    viewBox: "0 0 29 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3137 75.0089C28.3137 82.8275 21.9754 89.1657 14.1568 89.1657C6.33823 89.1657 0 82.8275 0 75.0089C0 67.1903 6.33823 60.8521 14.1568 60.8521C21.9754 60.8521 28.3137 67.1903 28.3137 75.0089ZM5.43855 75.0089C5.43855 79.8239 9.34186 83.7272 14.1568 83.7272C18.9718 83.7272 22.8751 79.8239 22.8751 75.0089C22.8751 70.1939 18.9718 66.2906 14.1568 66.2906C9.34186 66.2906 5.43855 70.1939 5.43855 75.0089Z",
    fill: "#F05203"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4786 0L22.9572 58.5716H6L14.4786 0Z",
    fill: "url(#paint0_linear_2851_3601)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2851_3601",
    x1: 14.4786,
    y1: 0,
    x2: 14.4786,
    y2: 58.5716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F05203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F05203",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressPointer);
export default __webpack_public_path__ + "static/media/progress-pointer.9a3555f2d36f6e97fa2fbae07d7d034c.svg";
export { ForwardRef as ReactComponent };